// POSCartDeliveryForm - Delivery mode form fields and payment selector for POSCart
import React from "react";
import { Truck } from "lucide-react";
import { Button } from "@/components/ui/button";

export function POSCartDeliveryForm({
  deliveryCustomerName,
  onDeliveryCustomerNameChange,
  deliveryCustomerPhone,
  onDeliveryCustomerPhoneChange,
  deliveryAddress,
  onDeliveryAddressChange,
  orderNotes,
  onNotesChange,
  deliveryNotes,
  onDeliveryNotesChange,
  deliveryPaymentMethod,
  onDeliveryPaymentMethodChange,
  total,
  subtotal,
  processing,
  onDeliveryCheckout,
  onDeliveryPhoneLookup,
}) {
  return (
    <>
      <div className="space-y-2">
        <p className="text-xs font-bold text-blue-600 uppercase flex items-center gap-1">
          <Truck className="w-3.5 h-3.5" /> Cliente Delivery
        </p>
        <input
          type="text"
          value={deliveryCustomerName}
          onChange={e => onDeliveryCustomerNameChange?.(e.target.value)}
          placeholder="Nome do cliente *"
          className="w-full text-sm rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 focus:outline-none focus:ring-1 focus:ring-blue-400"
        />
        <input
          type="tel"
          value={deliveryCustomerPhone}
          onChange={e => onDeliveryCustomerPhoneChange?.(e.target.value)}
          onBlur={e => onDeliveryPhoneLookup?.(e.target.value)}
          placeholder="Telemóvel (WhatsApp)"
          className="w-full text-sm rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 focus:outline-none focus:ring-1 focus:ring-blue-400"
        />
        <input
          type="text"
          value={deliveryAddress}
          onChange={e => onDeliveryAddressChange?.(e.target.value)}
          placeholder="Morada de entrega *"
          className="w-full text-sm rounded-lg border border-blue-200 bg-blue-50 px-2.5 py-1.5 focus:outline-none focus:ring-1 focus:ring-blue-400 placeholder:text-blue-300"
        />
        <textarea
          value={orderNotes}
          onChange={e => onNotesChange?.(e.target.value)}
          placeholder="Obs. do pedido (ex: sem cebola, alergia...)"
          rows={2}
          className="w-full text-sm rounded-lg border border-amber-200 bg-amber-50 px-2.5 py-1.5 resize-none focus:outline-none focus:ring-1 focus:ring-amber-400 placeholder:text-amber-300"
        />
        <textarea
          value={deliveryNotes}
          onChange={e => onDeliveryNotesChange?.(e.target.value)}
          placeholder="Observações da entrega (campainha, andar...)"
          rows={2}
          className="w-full text-sm rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 resize-none focus:outline-none focus:ring-1 focus:ring-blue-400 placeholder:text-gray-300"
        />
      </div>

      <div>
        <p className="text-xs font-bold text-gray-500 uppercase mb-1.5">Pagamento</p>
        <div className="grid grid-cols-2 gap-1.5">
          {[
            { key: "card_restaurant", label: "💳 Tarjeta na entrega" },
            { key: "cash", label: "💵 Dinheiro" },
            { key: "card", label: "💳 Cartão" },
            { key: "online", label: "🌐 Online" },
          ].map(pm => (
            <button
              key={pm.key}
              onClick={() => onDeliveryPaymentMethodChange?.(pm.key)}
              className={`py-2 rounded-lg border-2 text-xs font-bold transition-all ${
                deliveryPaymentMethod === pm.key
                  ? "border-blue-500 bg-blue-50 text-blue-700"
                  : "border-gray-200 text-gray-600 hover:border-gray-300"
              }`}
            >
              {pm.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex justify-between text-lg font-bold border-t pt-2">
        <span>Total</span>
        <span className="text-blue-600">{(total ?? subtotal).toFixed(2)}€</span>
      </div>

      <Button
        onClick={() => onDeliveryCheckout?.()}
        disabled={processing || !deliveryCustomerName.trim() || !deliveryAddress.trim()}
        className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold h-12 disabled:opacity-50"
        data-testid="checkout-delivery"
      >
        {processing ? "..." : "🚴 CRIAR PEDIDO DELIVERY"}
      </Button>
    </>
  );
}
